/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowElbowRight = createReactComponent(
  "arrow-elbow-right",
  "IconArrowElbowRight",
  [
    ["path", { d: "M21 14v-6h-6", key: "svg-0" }],
    ["path", { d: "M21 8l-9 9l-9 -9", key: "svg-1" }]
  ]
);

export { IconArrowElbowRight as default };
//# sourceMappingURL=IconArrowElbowRight.js.map
